module.exports = __webpack_public_path__ + "static/media/close_banner_icon.6e21e97e.svg";